import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';

import CloseIcon from 'material-ui/svg-icons/navigation/close';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import AutoComplete from 'material-ui/AutoComplete';

const style = {

    toolbar : {
        backgroundColor: 'rgb(255,255,255) !important',
        width: '100%',
        display: 'flex',
        minHeight: '64px',
        paddingLeft: '24px',
        paddingRight: '24px',
        top: 0,
        position: 'fixed',
        zIndex: 1100,
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12)',
        borderRadius: 0,
    },
    toolbarGroup1 : {
        marginTop: '8px',
        marginRight: '8px',
        marginLeft: '-16px',
        background: 'none',
        boxSizing: 'border-box',
        display: 'inline-block',
        font: 'inherit',
        cursor: 'pointer',
        textDecoration: 'none',
        outline: 'none',
        position: 'relative',
        fontSize: 0,
        color: '#FFF !important',
    },
    toolbarGroup2 : {
        marginTop: '8px',
        width: '80%',
    },
    toolbarGroup3 : {
        marginTop: '8px',
        marginRight: '-16px',
        marginLeft: 'auto',
        position: 'relative',
        textAlign: 'right',
    }
};
/**
 *
 * Generic search toolbar
 *
 * @prop function action, this function is called to perform a search
 * @prop function backTo, action for the back button
 * @prop array searchResult, array of simple objects
 */
const SearchToolbar = React.createClass({


    getInitialState: function() {
        return {
            query: ''
        };
    },

    componentDidMount: function() {
        this.refs.searchText.focus();
    },

    render: function() {
        const hintText = (this.props.hintText) ? `Search ${this.props.hintText}` : 'Search';

        return (
            <Toolbar 
                style={style.toolbar}
            >
                <ToolbarGroup
                    style={style.toolbarGroup1}
                    firstChild={true}
                >
                    <IconButton
                        onMouseUp={this.props.backTo}
                        onTouchEnd={this.props.backTo}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </ToolbarGroup>

                <ToolbarGroup 
                    style={style.toolbarGroup2}
                >
                    <AutoComplete
                        hintText={hintText}
                        searchText={this.state.query}
                        fullWidth={true}
                        disableFocusRipple={true}
                        animated={false}
                        underlineShow={false}
                        dataSource={this.props.searchResult}
                        onUpdateInput={this.onUpdateInput}
                        ref="searchText"
                    />
                </ToolbarGroup>

                <ToolbarGroup
                    style={style.toolbarGroup3}
                    lastChild={true}
                >
                    {(this.state.query.length >= this.props.minQueryLength) && (
                        <IconButton
                            onMouseUp={this.clearSearchText}
                            onTouchEnd={this.clearSearchText}
                        >
                            <CloseIcon />
                        </IconButton>
                    )}
                </ToolbarGroup>

            </Toolbar>
        );
    },

    onUpdateInput: function(text) {
        if(text.length >= this.props.minQueryLength) {
            this.props.action(text);
        }
        this.setState(assign({}, this.state, { query: text }));
    },

    clearSearchText: function() {
        this.setState(assign({}, this.state, { query: '' }));
    }


});

SearchToolbar.propTypes = {
    action: PropTypes.func.isRequired,
    backTo: PropTypes.func.isRequired,
    searchResult: PropTypes.array.isRequired
};

SearchToolbar.defaultProps = {
    minQueryLength: 2
};

export default SearchToolbar;
